export const HIGHLIGHT_COLOR = Styles.color.primary;

export const incentiveCardImageDefaultProps = {
  objectFitContain: true,
};

export const SHOULD_SELECT_STORE = true;
export const DISABLE_IN_RESTAURANT_FOR_INVALID_SERVICE_MODE = true;
